import React, { useState } from "react";

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(field);
    return copied;
  }
}

// One Share button on every device: it opens the device's share menu (phones, Macs, Windows) with the full
// invite message, or copies that message where the browser has no share menu.
// "Copy invite link" copies only the link.
export default function InviteActions({ text, url, subject, onShared = () => {}, primaryLabel = "Share invite" }) {
  const [copied, setCopied] = useState(false);
  // Sharing carries the intro message; the copy button copies just the link.
  const message = `${text} ${url}`;

  const share = () => {
    if (typeof navigator.share !== "function") {
      copy(message, "copy_message");
      return;
    }
    // The link goes inside the text: some apps drop the text when a separate url is passed.
    navigator
      .share({ title: subject, text: message })
      .then(() => onShared("share_sheet"))
      .catch((error) => {
        if (error?.name !== "AbortError") console.error("Could not share invite", error);
      });
  };

  const copy = (value = url, method = "copy_link") => {
    copyText(value).then((ok) => {
      if (!ok) return;
      onShared(method);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div className="rr-invite-actions">
      <button type="button" className="rr-btn rr-btn-primary" onClick={share}>
        {primaryLabel}
      </button>
      <div className="rr-link-box">
        <span className="rr-link-text">{url.replace(/^https?:\/\//, "")}</span>
        <button type="button" className="rr-link-copy" onClick={() => copy()}>
          {copied ? "Copied!" : "Copy invite link"}
        </button>
      </div>
    </div>
  );
}
